import {DrugType, PatientDrugRegimenType} from '../components/component.d';

/**
 * TODO: deprecate this. SIM: https://sim.amazon.com/issues/potux-1760
 * Returns the drug type, defaulting to RX for backward compatibility
 * @param type Optional drug type
 * @returns DrugType - RX if not specified
 */
export const getDrugType = (type?: DrugType): DrugType => type ?? DrugType.RX;

/**
 * Returns the medication type, defaulting to PRESCRIPTION
 * @param type Optional medication type
 * @returns PatientDrugRegimenType - PRESCRIPTION if not specified
 */
export const getPatientDrugRegimenType = (type?: PatientDrugRegimenType): PatientDrugRegimenType => type ?? PatientDrugRegimenType.PRESCRIPTION;

